// ** Initialize query key according to rules, clearly and meaningfully. **
const QUERY_KEY = Object.freeze({
  // * common
  GET_ALL_CHAT_FLAG: 'get-all-chat-flag',
  GET_LIST_CHAT_FLAG: 'get-list-chat-flag',
  GET_SETTING_DASHBOARD: 'get-setting-dashboard',
  GET_DATA_MASKING_CONFIG: 'get-data-masking-config',
  GET_ALL_DISTRICTS: 'get-all-districts',
  GET_ALL_CITIES: 'get-all-cities',
  GET_ALL_ORGANIZATION: 'get-all-organization',
  GET_ALL_SERVICES: 'get-all-services',
  GET_ALL_SCHEDULES: 'get-all-schedules',
  GET_ALL_DISTRICT_BY_CITY_ID: 'get-all-district-by-city-id',
  GET_ALL_TEMPLATE_CATALOG: 'get-all-template-catalog',
  GET_ALL_CHAT_TEMPLATE: 'get-all-chat-template',
  GET_ALL_WHATSAPP_TEMPLATE: 'get-all-whatsapp-template',
  GET_ALL_FILTERS: 'get-all-filters',
  GET_ALL_CAMPAIGN: 'get-all-campaign',
  GET_FILE_PREVIEW: 'get-file-preview',
  GET_LIST_TEMPLATE: 'get-list-template',
  GET_LIST_TEMPLATE_CATALOG: 'get-list-template-catalog',
  GET_LIST_CUSTOMER: 'get-list-customer',
  GET_LIST_CAMPAIGN_CONTACT: 'get-list-campaign-contact',
  GET_LIST_BLACKLIST: 'get-list-blacklist',
  GET_LIST_SCHEDULE: 'get-list-schedule',
  GET_LIST_SCHEDULE_PERIOD: 'get-list-schedule-period',
  GET_DETAIL_ORGANIZATION: 'get-detail-organization',
  GET_CHAT_CONFIG: 'get-chat-config',
  // * monitor
  GET_DAILY_CHANNEL_STAT: 'get-daily-channel-stat',
  GET_DAILY_CALL_STAT: 'get-daily-call-stat',
  GET_TOTAL_EMAIL_IN_QUEUE: 'get-total-email-in-queue',
  // * report
  GET_SUMMARY_REPORT: 'get-summary-report',
  GET_SUMMARY_AGENT_REPORT: 'get-summary-agent-report',
  GET_SUMMARY_GROUP_REPORT: 'get-summary-group-report',
  GET_SUMMARY_PERSONAL_REPORT: 'get-summary-personal-report',
  GET_SUMMARY_CUSTOMER_REPORT: 'get-summary-customer-report',
  GET_SUMMARY_TICKET_REPORT: 'get-summary-ticket-report',
  GET_SUMMARY_TIME_PROCESS_TICKET_REPORT:
    'get-summary-time-process-ticket-report',
  GET_DETAIL_AGENT_REPORT: 'get-detail-agent-report',
  GET_DETAIL_SUMMARY_GROUP_REPORT: 'get-detail-summary-group-report',
  GET_CALL_REPORT: 'get-call-report',
  GET_CALL_REPORT_BY_HOUR: 'get-call-report-by-hour',
  GET_CALL_REPORT_IN_YEAR: 'get-call-report-in-year',
  GET_CALL_HISTORY_REPORT: 'get-call-history-report',
  GET_CUSTOM_REPORT: 'get-custom-report',
  GET_REPORT_AD_FUNNEL: 'get-report-ad-funnel',
  GET_REPORT_AD_FUNNEL_BY_SOURCE: 'get-report-ad-funnel-by-source',
  // * chat
  GET_CHAT_LIST: 'get-chat-list',
  GET_CHAT_MESSAGES: 'get-chat-messages',
  GET_CHAT_ASSIGN_AGENT: 'get-chat-assign-agent',
  GET_DETAIL_CHAT_TICKET: 'get-detail-chat-ticket',
  GET_LAST_CHAT_HISTORY: 'get-last-chat-history',
  FIND_CHAT_MESSAGES: 'find-chat-messages',

  // * user
  GET_LIST_USER: 'get-list-user',
  GET_LIST_USER_GROUP: 'get-list-user-group',
  GET_LIST_ORGANIZATION: 'get-list-organization',
  GET_ALL_AGENTS: 'get-all-agents',
  GET_ALL_AGENT_WITH_GROUP: 'get-all-agent-with-group',
  GET_ALL_USER_FIELDS: 'get-all-user-fields',
  GET_ALL_GROUPS: 'get-all-groups',
  GET_ALL_USER_GROUPS: 'get-all-user-groups',
  GET_ALL_CUSTOMER_GROUPS: 'get-all-customer-groups',
  GET_LIST_USER_ATTRIBUTES: 'get-list-user-attributes',
  GET_LIST_CUSTOMER_GROUPS: 'get-list-customer-groups',
  GET_LIST_CUSTOMER_TAGS: 'get-list-customer-tags',
  GET_USER_CONFIGURATION: 'get-user-configuration',
  // * ticket
  GET_DETAIL_TICKET: 'get-detail-ticket',
  GET_REQUESTER: 'get-requester',
  GET_TICKET_COMMENTS: 'get-ticket-comments',
  GET_ALL_TICKET_STATUS: 'get-all-ticket-status',
  GET_ALL_TICKET_FIELDS: 'get-all-ticket-fields',
  GET_LIST_TICKET_ATTRIBUTES: 'get-list-ticket-attribute',
  GET_LIST_TICKET_PRIORITIES: 'get-list-ticket-priority',
  GET_LIST_TICKET_TEMPLATE: 'get-list-ticket-template',
  GET_LIST_TICKET_TYPES: 'get-list-ticket-types',
  GET_LIST_TICKETS: 'get-list-tickets',
  GET_LIST_USER_TICKETS: 'get-user-list-tickets',
  GET_ASSIGN_AGENT: 'get-assign-agent',
  // ** multiple channels
  GET_ALL_ZALO_OA: 'get-all-zalo-oa',
  GET_ALL_WHATSAPP: 'get-all-whatsapp',

  GET_ZNS_TEMPLATE_BY_OA: 'get-zns-template-by-oa',
  GET_ALL_SMS_BRAND_NAME: 'get-all-sms-brand_name',
  GET_ALL_EMAIL_ACCOUNTS: 'get-all-email-accounts',
  GET_ALL_TEMPLATES: 'get-all-templates',
  GET_ALL_EMAIL_TEMPLATES: 'get-all-email-templates',
  GET_ALL_ZNS_TEMPLATES: 'get-all-zns-templates',
  GET_ALL_SMS_TEMPLATES: 'get-all-sms-templates',
  GET_LIST_SMS_BRAND_NAME: 'get-list-sms-brand-name',
  GET_LIST_EMAIL: 'get-list-email',
  GET_LIST_FACEBOOK_PAGE: 'get-list-facebook-page',
  GET_LIST_ZALO_OA: 'get-list-zalo-oa',
  GET_LIST_ZNS_TEMPLATE: 'get-list-zns-template',
  POST_SAVE_ZALO_INFO: 'post-save-zalo-info',
  GET_LIST_WHATSAPP: 'get-list-whatsapp',
  GET_LIST_ZALO_USER_DOMAIN: 'get-list-zalo-user-domain',
  GET_LIST_ZALO_USER_ACCOUNT: 'get-list-zalo-user-account',
  GET_ZALO_DOMAIN_BY_TENANT_ID: 'get-zalo-domain-by-tenant-id',
  GET_LIST_WHATSAPP_TEMPLATE: 'get-list-whatsapp-template',

  // ** ivr
  GET_ALL_IVR_GATEWAYS: 'get-all-ivr-gateways',
  GET_ALL_IVR_STATE_TYPE: 'get-all-ivr-state-type',
  GET_ALL_IVR_AUDIO_FILES: 'get-all-ivr-audio-files',
  GET_LIST_IVR_AUDIO_FILE: 'get-list-ivr-audio-file',
  GET_LIST_IVR_SCRIPT: 'get-list-ivr-script',
  // ** queue
  GET_LIST_QUEUE: 'get-list-queue',
  GET_LIST_PARAMS_IN_QUEUE: 'get-list-params-in-queue',
  GET_ALL_QUEUES: 'get-all-queues',
  GEY_AGENT_IN_QUEUE: 'get-agent-in-queue',
  GET_CALL_OUT_QUEUES: 'get-call-out-queues',
  //
  SMART_QC: 'smart-qc',
  GET_LIST_SMART_MANUAL_QC: 'get-list-smart-manual-qc',
  GET_LIST_SMART_AUTO_QC: 'get-list-smart-auto-qc',
  GET_LIST_SMART_QC_TICKET: 'get-list-smart-qc-ticket',
  GET_LIST_KEYWORD_QC: 'get-list-keyword-qc',
  GET_All_KEYWORD_QC: 'get-all-keyword-qc',

  GET_CALL_CRITERIA_TEMPLATE_QC: 'get-call-criteria-template',
  GET_CHAT_CRITERIA_TEMPLATE_QC: 'get-chat-criteria-template',
  GET_QC_CAMP_DETAIL_SUMMARY: 'get-qc-camp-detail-summary',
  GET_QC_TICKET_DETAIL_SUMMARY: 'get-qc-ticket-detail-summary',
  GET_QC_TICKET_DETAIL_HISTORY: 'get-qc-ticket-detail-history',
  // smart view
  GET_LIST_SMART_VIEWS: 'get-smart-views',
  // Workflow
  GET_LIST_WORKFLOW: 'get-list-workflow',
  GET_WORKFLOW_BY_ID: 'get-workflow',
  GET_WORKFLOW_HISTORIES: 'get-workflow-histories',
  // tag
  GET_LIST_TAGS: 'get-tags',
  GET_TENANT_CONFIG: 'get-tenant-config',
  GET_FILTER_GROUPS_BY_TENANT_ID: 'get-filter-groups-by-tenant-id',
  GET_FILTER_USERS_BY_TENANT_ID: 'get-filter-users-by-tenant-id',
  GET_ALL_DOMAINS: 'get-all-domains',
  GET_USER_INFO: 'get-user-info',
  //tenant settings
  GET_LIST_TENANT: 'get-list-tenant',
  GET_DETAIL_TENANT: 'get-detail-tenant',
  GET_LIST_TENANT_AGENT: 'get-list-tenant-agent',
  GET_ALL_TENANT_GROUPS: 'get-all-tenant-groups',
  GET_LIST_TENANT_IVRGATEWAY: 'get-list-tenant-ivr-gateway',
})
export default QUERY_KEY
